import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3003';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
let interceptorId = null;

export const setAuthToken = (getToken) => {
  if (interceptorId !== null) {
    api.interceptors.request.eject(interceptorId);
  }
  interceptorId = api.interceptors.request.use(async (config) => {
    try {
      const token = await getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (err) {
      // Token unavailable — request goes without auth
    }
    return config;
  });
};

export default api;
